// extracted by mini-css-extract-plugin
export default {"value":"AddressDisplay_value__G2M2D"};